const $Navigation3AMenuItemContentTrigger = $('.js-menu-item-content-trigger', '.component-navigation-3A');

const Navigation3A = document.getElementsByClassName('component-navigation-3A--state')[0];
const Navigation3ATop = document.getElementsByClassName('component-navigation-3A__top')[0];
const Navigation3ABottom = document.getElementsByClassName('component-navigation-3A__bottom')[0];

if (Navigation3A && Navigation3ATop && Navigation3ABottom) {
    let Navigation3AIsPastTop = false;
    let Navigation3AIsPastBottom = false;
    let Navigation3ABottomObserver;

    //1. Observer for Point A (Start Sticky)
    const topObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            Navigation3AIsPastTop = !entry.isIntersecting && entry.boundingClientRect.y < 0;
            Navigation3AUpdateNavState();
        });
    });
    topObserver.observe(Navigation3ATop);
    
    // 2. Function to build the bottom observer
    function Navigation3ACreateBottomObserver() {
        // Clear out the old observer if it exists
        if (Navigation3ABottomObserver) {
            Navigation3ABottomObserver.disconnect();
        }

        const Navigation3AHeight = Navigation3A.offsetHeight;

        Navigation3ABottomObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                Navigation3AIsPastBottom = !entry.isIntersecting && entry.boundingClientRect.y <= (Navigation3AHeight + 2);
                Navigation3AUpdateNavState();
            });
        }, {
            // Set the new margin based on the fresh height
            rootMargin: `-${Navigation3AHeight}px 0px 0px 0px` 
        });
        
        Navigation3ABottomObserver.observe(Navigation3ABottom);
    }

    // Initialize the bottom observer on page load
    Navigation3ACreateBottomObserver();

    // 3. ResizeObserver to catch display: none -> display: block changes
    const resizeObserver = new ResizeObserver(() => {
        // Force a manual check of the top trigger. This catches the layout shift 
        // if the trigger was already scrolled past while the nav was hidden.
        Navigation3AIsPastTop = Navigation3ATop.getBoundingClientRect().y < 0;
        
        Navigation3ACreateBottomObserver();
        Navigation3AUpdateNavState();
    });
    resizeObserver.observe(Navigation3A);

    // 4. Central Logic for the Nav State
    function Navigation3AUpdateNavState() {
        // Safeguard: If the nav is hidden on mobile, strip sticky classes and stop
        if (Navigation3A.offsetHeight === 0) {
            Navigation3A.classList.remove('is-sticky', 'is-hidden');
            return;
        }

        if (!Navigation3AIsPastTop) {
            // Zone 1: Above Point A (Normal flow)
            Navigation3A.classList.remove('is-sticky', 'is-hidden');
            
        } else if (Navigation3AIsPastTop && !Navigation3AIsPastBottom) {
            // Zone 2: Between Point A and Point B (Strictly Sticky)
            Navigation3A.classList.add('is-sticky');
            Navigation3A.classList.remove('is-hidden');
            
        } else if (Navigation3AIsPastBottom) {
            // Zone 3: Below Point B (Inactive/Hidden)
            Navigation3A.classList.remove('is-sticky');
            Navigation3A.classList.add('is-hidden');
        }
    }
}

$Navigation3AMenuItemContentTrigger.on('click', function() {
    var $that = $(this);
    var $SubNavigation = $that.parents('.component-navigation-3A__sub-navigation');
    var $SubNavigationBlock = $that.parents('.component-navigation-3A__sub-navigation-block');
    var $SubNavigationTopLevelItemContent = $that.next('.component-navigation-3A__sub-navigation-top-level-item-content');
    var $SubNavigationTopLevelItemContentInnerContainer = $('.component-navigation-3A__sub-navigation-top-level-item-content-inner-container', $SubNavigationTopLevelItemContent);
    var height = $SubNavigationTopLevelItemContentInnerContainer.outerHeight(true);
    
    if ($SubNavigationBlock.is('.active')) {
        $SubNavigationBlock.removeClass('active')
        $SubNavigationTopLevelItemContent.height(0);
    } else {
        $('.component-navigation-3A__sub-navigation-block', $SubNavigation).removeClass('active');
        $('.js-menu-item-content-trigger', $SubNavigation).removeClass('active');
        $('.component-navigation-3A__sub-navigation-top-level-item-content', $SubNavigation).height(0);
        
        $SubNavigationBlock.addClass('active');
        $SubNavigationTopLevelItemContent.height(height);
    }
});